/* global window */
import React from 'react';
import immJS from 'lodash';
import { Icon, Button, Tooltip } from 'antd';
import moment from 'moment';
import { FormattedMessage, defineMessages } from 'react-intl';
import EventToolTipComponent from '../EventToolTip/EventToolTipComponent';
import CreateMeetingContainer from '../../Containers/CreateMeeting/CreateMeetingContainer';
import { getParameterValue } from '../../Repositories/CalendarRepository';
import './EventComponent.scss';
import EventContent from '../EventContent/EventContentComponent';

const messages = defineMessages({
  candidateAcceptedStatus: {
    id: 'Event.CandidateAcceptedStatus',
    defaultMessage: 'Accepted by the candidate',
  },
  candidateDeclinedStatus: {
    id: 'Event.CandidateDeclinedStatus',
    defaultMessage: 'Declined by the candidate',
  },
  candidateYetToAcceptStatus: {
    id: 'Event.CandidateYetToAcceptStatus',
    defaultMessage: 'Yet to be accepted by the candidate',
  },
  recruiterDeclinedStatus: {
    id: 'Event.RecruiterDeclinedStatus',
    defaultMessage: 'Declined by you',
  },
});

function getStatusText(accepted, pending, declined) {
  return `Recipients accepted ${accepted}; pending ${pending}; declined ${declined}`;
}

function handleBlur(e = 0) {
  if (e !== 0) {
    e.stopPropagation();
  }
}

class Event extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonClassName: 'event-actions-hidden',
    };
    this.eventRef = React.createRef();
    this.handleHover = this.handleHover.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleToolTipClick = this.handleToolTipClick.bind(this);
    this.getDataForEvent = this.getDataForEvent.bind(this);
  }

  getDataForEvent() {
    const recruiterEmail = getParameterValue('username');
    let recruiterStatus;
    const candidates = [];
    let accepted = 0;
    let pending = 0;
    let declined = 0;
    let statusText;
    const { event } = this.props;

    event.Attendees.forEach(attendee => {
      if (attendee.Email === recruiterEmail) {
        recruiterStatus = attendee.Status;
      } else {
        let email = attendee.Email;
        let status = attendee.Status;
        let role = attendee.Role;
        if (status) {
          status = status.toLowerCase();
        } else {
          status = 'NA';
          email = '';
          role = '';
        }

        candidates.push({ email, status, role });
      }
    });

    candidates.forEach(candidate => {
      switch (candidate.status) {
        case 'confirmed':
          accepted += 1;
          break;
        case 'declined':
          declined += 1;
          break;
        case 'waiting':
          pending += 1;
          break;
        default:
          pending += 1;
          break;
      }
    });

    if (recruiterStatus) {
      recruiterStatus = recruiterStatus.toLowerCase();
    } else {
      recruiterStatus = 'confirmed';
    }
    if (recruiterStatus === 'confirmed') accepted += 1;
    else if (recruiterStatus === 'declined') declined += 1;
    statusText = getStatusText(accepted, pending, declined);
    if (recruiterStatus === 'Declined') {
      statusText = <FormattedMessage {...messages.recruiterDeclinedStatus} />;
    }
    return {
      className: event.Status === 'Declined' ? `${recruiterStatus}-declined` : `${recruiterStatus}-waiting`,
      statusText,
      candidates,
      recruiterStatus,
    };
  }

  handleClick(e, action) {
    e.stopPropagation();
    const { event, updateEvent, deleteEvent } = this.props;
    const newDetails = immJS.cloneDeep(event);
    if (action !== 'DELETE') {
      if (action === 'YES') {
        newDetails.AttendeeStatus = 'Confirmed';
      } else if (action === 'NO') {
        newDetails.AttendeeStatus = 'Declined';
      } else if (action === 'Propose') {
        newDetails.AttendeeStatus = 'Proposed';
      }
      const recruiterEmail = getParameterValue('username');
      for (let index = 0; index < newDetails.Attendees.length; index += 1) {
        if (newDetails.Attendees[index].Email === recruiterEmail) {
          newDetails.Attendees[index].Status = newDetails.AttendeeStatus;
        }
      }
      updateEvent(newDetails, action);
    } else {
      deleteEvent(event);
    }
  }

  handleHover() {
    const width = this.eventRef.current.parentNode.clientWidth;
    const { parent, style } = this.props;
    if (parent === 'in-day' && (parseInt(style.width, 10) * width) / 100 >= 600) {
      this.setState({
        buttonClassName: 'event-actions',
      });
    }
  }

  handleMouseLeave() {
    this.setState({
      buttonClassName: 'event-actions-hidden',
    });
  }

  handleToolTipClick(e) {
    const y = e.screenY;
    let placement;
    if (y < window.innerHeight / 2 + 136) {
      placement = 'bottom';
    } else {
      placement = 'top';
    }
    const { style, parent } = this.props;
    const width = this.eventRef.current.parentNode.clientWidth;
    const eventComponentLeft = (1 - parseInt(style.left, 10) / 100) * width;
    if (eventComponentLeft < 398 && parent === 'in-day') {
      placement = 'left';
    }
    this.setState({
      placement,
    });
  }

  render() {
    const { startDate, endDate, type, event, deleteEvent, style, parent } = this.props;
    const { buttonClassName, placement } = this.state;
    const startTime = moment(startDate, 'hh:mm a');
    const endTime = moment(endDate, 'hh:mm a');
    let eventClassName;
    let eventStatusText;
    let candidates = [];
    let eventData;
    let actions;
    let actionButtons;
    let removeButton;
    let overlay;
    const title = event.Summary;
    if (type === 'arya') {
      eventData = this.getDataForEvent();
      eventStatusText = eventData.statusText;
      eventClassName = eventData.className;
      candidates = immJS.get(eventData, 'candidates', []);
      if (event.Status === 'Declined') {
        removeButton = (
          <Button
            className="actions-button remove-button"
            onClick={e => {
              this.handleClick(e, 'DELETE');
            }}
            style={{ height: 'inherit', verticalAlign: 'middle' }}
          >
            Remove from calendar
          </Button>
        );
      }
      if (event.Status !== 'Declined' && moment(endDate).isAfter(moment())) {
        actionButtons = (
          <React.Fragment>
            <Button
              className="actions-button yes-button"
              onClick={e => {
                this.handleClick(e, 'YES');
              }}
              disabled={eventData.recruiterStatus === 'confirmed'}
              style={{ height: 'inherit', verticalAlign: 'middle' }}
            >
              {eventData.recruiterStatus === 'confirmed' ? <Icon type="check" /> : null}
              Yes
            </Button>
            <Button
              className="actions-button"
              onClick={e => {
                this.handleClick(e, 'NO');
              }}
              disabled={eventData.recruiterStatus === 'declined'}
              style={{ height: 'inherit', verticalAlign: 'middle' }}
            >
              {eventData.recruiterStatus === 'declined' ? <Icon type="close" /> : null}
              No
            </Button>
          </React.Fragment>
        );
      }
      actions = (
        <div className={buttonClassName}>
          {actionButtons}
          <span
            className="propose-button-event"
            onClick={e => {
              handleBlur(e);
            }}
            role="button"
            tabIndex={0}
            onKeyPress={e => {
              handleBlur(e);
            }}
          >
            <CreateMeetingContainer type="update" event={event} title="Propose" candidates={candidates} />
          </span>
          {removeButton}
        </div>
      );
      overlay = (
        <EventToolTipComponent
          handleClick={this.handleClick}
          event={event}
          type={type}
          startTime={moment(startTime).format('hh:mm a')}
          endTime={moment(endTime).format('hh:mm a')}
          onBlur={handleBlur}
          recruiterStatus={eventData.recruiterStatus}
          candidates={candidates}
          deleteEvent={deleteEvent}
          eventStatusText={eventStatusText}
        />
      );
    } else {
      eventClassName = 'event-external';
    }

    return (
      <Tooltip
        overlay={overlay}
        trigger={['click']}
        placement={placement}
        // overlayClassName="event-tool-tip"
        // overlayStyle={{
        //   minHeight: '250px',
        // }}
        getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <div
          role="button"
          title={title}
          style={style}
          className={eventClassName}
          onKeyPress={this.handleToolTipClick}
          onMouseOver={this.handleHover}
          onMouseLeave={this.handleMouseLeave}
          onFocus={this.handleHover}
          onClick={e => this.handleToolTipClick(e)}
          tabIndex={0}
          ref={this.eventRef}
        >
          <EventContent
            event={event}
            parent={parent}
            startTime={startTime}
            endTime={endTime}
            candidates={candidates}
            eventStatusText={eventStatusText}
            type={type}
          />
          {actions}
        </div>
      </Tooltip>
    );
  }
}

// Event.propTypes = {
//   parent: PropTypes.string,
//   startDate: PropTypes.shape({}),
//   endDate: PropTypes.shape({}),
//   event: PropTypes.shape({
//     Status: PropTypes.string,
//     Summary: PropTypes.string,
//     Attendees: PropTypes.arrayOf(
//       PropTypes.shape({
//         Status: PropTypes.string,
//         Email: PropTypes.string,
//         Role: PropTypes.string,
//       })
//     ),
//   }),
//   updateEvent: PropTypes.func.isRequired,
//   deleteEvent: PropTypes.func.isRequired,
//   type: PropTypes.string,
//   style: PropTypes.shape({
//     width: PropTypes.string,
//     left: PropTypes.string,
//   }),
// };

// Event.defaultProps = {
//   style: {
//     width: '100%',
//     left: '0%',
//   },
//   parent: '',
//   startDate: {},
//   endDate: {},
//   event: {
//     Status: '',
//     Summary: '',
//     Attendees: [],
//   },
//   type: '',
// };

export default Event;
